import { Alert } from '@ps/sports-ui-component-library';
import React from 'react';

import Translation from '@swf/components/Translation/Translation';
import type { Odds as OddsType } from '@swf/generated/types/api/sports';
import { Odds } from '@swf/sports/components/Odds/Odds';

import { TXTWCL_We_are_unable_to_place_this_be_ELL } from './MinOddsAlert.messages.json';
import styles from './MinOddsAlert.scss';

interface Props {
  minOdds: OddsType;
}

const MinOddsAlert: React.FC<Props> = ({ minOdds }) => (
  <Alert level="destructive" variant="passive-aggressive" className={styles.alert}>
    <Translation
      {...TXTWCL_We_are_unable_to_place_this_be_ELL}
      values={{
        0: <Odds {...minOdds} />
      }}
    />
  </Alert>
);

export default MinOddsAlert;
